unit uGrafico;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls, WEBLib.Controls;

type
  TGrafico = class(TForm)
  protected procedure LoadDFMValues; override; end;

var
  Grafico: TGrafico;

implementation

{$R *.dfm}

procedure TGrafico.LoadDFMValues;
begin
  inherited LoadDFMValues;


  try
    Name := 'Grafico';
    Width := 700;
    Height := 383;
    Caption := 'Datas de Leitura';
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
  finally
  end;
end;

end.
